import axios from 'axios'

const state = {
  coordinationCases: [],
  coordinationCaseTypes: []
}

const actions = {
  fetchCoordination: async ({ commit }, conversationID) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get('/coordination-case', {
          params: {
            conversation_id: conversationID
          }
        })
        commit('SET_COORDINATION_CASE', data.coordination_cases)
        commit('SET_COORDINATION_CASE_TYPES', data.coordination_case_types)
        resolve(data)
      } catch (err) {
        reject(err)
      }
    })
  }
}

const mutations = {
  SET_COORDINATION_CASE: (state, data) => {
    state.coordinationCases = JSON.parse(JSON.stringify(data))
  },
  SET_COORDINATION_CASE_TYPES: (state, data) => {
    state.coordinationCaseTypes = JSON.parse(JSON.stringify(data))
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
